import { Instagram } from "lucide-react";

export const IG_DEFAULT = { post: true, story: true, caption: "" };

export function DayInstagram({ value, onChange }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  return (
    <div className="radio-group day-ig" data-testid="special-day-instagram">
      <span className="radio-title"><Instagram size={13} />Instagram'da da paylaş</span>
      <div className="day-ig-row">
        <label className="check-label"><input type="checkbox" checked={value.post} onChange={set("post")} data-testid="special-day-ig-post" />Post</label>
        <label className="check-label"><input type="checkbox" checked={value.story} onChange={set("story")} data-testid="special-day-ig-story" />Story</label>
      </div>
      {value.post && <label>Instagram açıklaması<textarea className="plain-textarea" rows={2} maxLength={2200} value={value.caption} onChange={set("caption")} placeholder="Boş bırakırsanız WhatsApp mesajı kullanılır" data-testid="special-day-ig-caption" /></label>}
      <small className="form-hint">{value.post || value.story ? "Zamanla'ya bastığınızda afiş WhatsApp ile aynı gün ve saatte Instagram'da da otomatik paylaşılır. #etiket ekleyebilirsiniz." : "Bu özel gün Instagram'da paylaşılmaz."}</small>
    </div>
  );
}
